var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundHollowStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.2344C12.1406 15.2344 15.5703 11.8047 15.5703 7.66406C15.5703 3.52344 12.1328 0.09375 7.99219 0.09375C3.85156 0.09375 0.421875 3.52344 0.421875 7.66406C0.421875 11.8047 3.85938 15.2344 8 15.2344ZM5.82031 11.5938C5.375 11.9375 4.89844 11.5859 5.07031 11.0547L5.92969 8.5L3.73438 6.92969C3.32031 6.625 3.45312 6.02344 4.02344 6.03125L6.71875 6.05469L7.53125 3.48438C7.69531 2.96875 8.28125 2.96875 8.44531 3.48438L9.26562 6.05469L11.9531 6.03125C12.5391 6.02344 12.6562 6.63281 12.25 6.92969L10.0547 8.5L10.9141 11.0547C11.0859 11.5859 10.6094 11.9375 10.1641 11.5938L7.99219 10.0078L5.82031 11.5938Z",
    fill: "#838AA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundHollowStar);
export default __webpack_public_path__ + "static/media/icon-round-hollow-star.2b4fd1a60ccefd4e65dc57a782818ebf.svg";
export { ForwardRef as ReactComponent };